import { useTranslation } from 'react-i18next';
import { Addon } from '@domain/addon';
import { Admission, AdmissionType } from '@domain/admission';
import { getDefaultOfferNameTranslation } from '@utils/get-default-offer-name-translation/get-default-offer-name-translation';
import { getTranslatedPropertyBasedOnOrder } from '@utils/get-translated-property-based-on-order/get-translated-property-based-on-order';

import { SummaryTableBody } from './SummaryTableBody';

interface SummaryTableProps {
  name: string;
  quantity: number;
  offer: Admission;
  addons?: Addon[];
  formAddons?: string[];
  fullName?: string;
  showHeader?: boolean;
  isInvitation?: boolean;
}
export const SummaryTable = ({ quantity, offer, addons, formAddons, fullName, isInvitation }: SummaryTableProps) => {
  const { t, i18n } = useTranslation();

  const offerName =
    getTranslatedPropertyBasedOnOrder({
      translations: offer?.name,
      preferredLanguage: i18n.language,
    }) ?? t(getDefaultOfferNameTranslation(offer.admissionType as AdmissionType));

  return (
    <section className='flex-col justify-start items-center flex w-full rounded-lg mb-6 sm:mb-8'>
      <SummaryTableBody
        fullName={fullName}
        quantity={quantity}
        offer={offer}
        addons={addons}
        formAddons={formAddons}
        offerName={offerName}
        isInvitation={isInvitation}
      />
    </section>
  );
};
